export default __webpack_public_path__ + "cocacola.2aa6eeb0.png";